import { Timestamp } from "@angular/fire/firestore"

/**
 * Filter type for owner-edited charts
 * - 'all': Show all charts regardless of edit status
 * - 'edited': Show only charts edited by the owner
 * - 'not-edited': Show only charts not edited by the owner
 */
export type OwnerEditedFilterType = "all" | "edited" | "not-edited"

/**
 * Valid values for owner edited filter (used for validation)
 */
export const VALID_OWNER_EDITED_FILTERS: OwnerEditedFilterType[] = [
  "all",
  "edited",
  "not-edited",
]

/**
 * Dashboard preferences for individual users
 */
export interface DashboardPreferences {
  /** Array of active status filter values (e.g., ["Processing", "In Review", "Ready"]) */
  statusFilters: string[]
  /** Whether notification chime is enabled */
  chimeEnabled: boolean
  /** Selected summary type filter (empty string for "All") */
  summaryTypeFilter: string
  /** Filter for owner-edited charts ('all' | 'edited' | 'not-edited') */
  ownerEditedFilter: OwnerEditedFilterType
  /**
   * Whether the "Deleted" chip is active. CAB-597: this chip is unioned with
   * statusFilters, so it ADDS deleted charts to the result rather than
   * restricting the list to them.
   */
  showDeleted: boolean
  /** Last update timestamp */
  updatedAt?: Timestamp
  /** Creation timestamp */
  createdAt?: Timestamp
}

/**
 * Default preferences for new users
 * Empty statusFilters means "show all statuses" (no filtering)
 */
export const DEFAULT_DASHBOARD_PREFERENCES: Omit<
  DashboardPreferences,
  "updatedAt" | "createdAt"
> = {
  statusFilters: [],
  chimeEnabled: false,
  summaryTypeFilter: "",
  ownerEditedFilter: "all",
  showDeleted: false,
}
